import React, { Component } from 'react';

//redux
import { connect } from 'react-redux';

//Components
import NavBar from '../../../../../_components/common/Navbar';
import Footer from '../../../../../_components/common/Footer';
import { CommonBreadCrumb } from '../../../../../_components/common/CommonBreadCrumb';
import SettingsHead from '../../../../../_components/common/SettingsHead';
import CustomTableNew from '../../../../../_components/common/CustomTableNew';
import ModalNew2 from '../../../../../_components/common/ModalNew2';
import { LoaderComp } from '../../../../../_components/common/LoaderComp/Loadercomp';
import Page404 from '../../../../404page';





//actions
import { worksheetAction } from '../../../../../_actions/WorkSheet/workSheet.action';


//column data for tabl
import table from '../../tableData';


//css
import './shared.css';

class WorksheetShare extends Component {
    state = {
        workSheetId: 0,
        shareWorkSheetState: 0,
        removeShareState: 0,
        removeShareMessage: [],
        dataToDelete: [],
        checkBoxData: [],
        reRenderSettingsHead: 1,
        getSharedWithUsersData: '',
        sharedButtonData: [],

        hasProperId: true,
        idLoader: true
    }

    componentDidMount() {

        const { dispatch } = this.props


        let hasId = true

        if (this.props.location.state === undefined) {
            hasId = false
        }

        this.setState({
            hasProperId: hasId,
            idLoader: false
        })

        let workSheetId = JSON.parse(localStorage.getItem('worksheetId')).id
        this.setState({
            sharedButtonData: [{
                id: 1,
                heading: "SHARE WORKSHEET",
                state: this.state.shareWorkSheetState,
                toggler: this.shareWorkSheetToggler.bind(this),
            }, {
                id: 2,
                heading: "REMOVE SHARING",
                state: this.state.removeShareState,
                toggler: this.removeShareToggler.bind(this),
                disabled: 'disabled'
            }],
            workSheetId
        }, () => {
            dispatch(worksheetAction.getSharedWithUsersHandler(workSheetId));
        })
    }

    componentDidUpdate(prevProps) {
        if (prevProps.getSharedWithUsersData !== this.props.getSharedWithUsersData) {
            this.setState({
                getSharedWithUsersData: this.props.getSharedWithUsersData
            })
        }
    }

    shareWorkSheetToggler(data) {
        this.setState({
            shareWorkSheetState: !this.state.shareWorkSheetState
        })
    }
    removeShareToggler(data) {
        let textAppendMessage = ''
        let removeShareMessage = []
        let checkBoxData = [...this.state.checkBoxData]

        let dataToDelete = []



        checkBoxData.map((val, key) => {
            dataToDelete.push(val.id)
            if (checkBoxData.length > 1) {
                if (key === 0) {
                    let text = `Remove access to the following ${checkBoxData.length} users?`
                    removeShareMessage.push({ text })
                    if (checkBoxData.length - 1 === key) {
                        textAppendMessage += val.shared_to__email + '.'
                    } else if (checkBoxData.length - 2 === key) {
                        textAppendMessage += val.shared_to__email + ' and '
                    } else {
                        textAppendMessage += val.shared_to__email + ', '
                    }
                } else {
                    if (checkBoxData.length - 1 === key) {
                        textAppendMessage += val.shared_to__email + '.'
                    } else if (checkBoxData.length - 2 === key) {
                        textAppendMessage += val.shared_to__email + ' and '
                    } else {
                        textAppendMessage += val.shared_to__email + ', '
                    }
                }
            } else {
                let text = `Remove access to ${val.shared_to__short_name !== null ? `${val.shared_to__short_name}. (${val.shared_to__email})` : `${val.shared_to__email}`}`
                removeShareMessage.push({ text })

            }
        })



        removeShareMessage.push({ text: textAppendMessage !== '' && textAppendMessage })


        this.setState({
            dataToDelete,
            removeShareMessage,
        }, () => {

            this.setState({
                removeShareState: !this.state.removeShareState,
            })
        })
    }
    filterData(data) {

        this.setState({
            getSharedWithUsersData: data
        })
    }



    //checkbox functions
    selectAllBatch(data, clickToggle) {
        const { sharedButtonData } = this.state

        if (clickToggle === true) {
            sharedButtonData.map(val => {
                if (val.disabled !== undefined) {
                    val.disabled = ''
                    this.setState({
                        reRenderSettingsHead: 2,
                    })
                }
            })
        } else {
            sharedButtonData.map(val => {
                if (val.disabled !== undefined) {
                    val.disabled = 'disabled'
                    this.setState({
                        reRenderSettingsHead: 1,
                    })
                }
            })
        }
    }
    getSelectedData(data) {
        if (data.length !== 0) {
            this.setState({ checkBoxData: data }, () => {
                this.selectAllBatch(this.state.checkBoxData, true)
            })
        } else if (data.length === 0) {
            this.setState({ checkBoxData: data }, () => {
                this.selectAllBatch(this.state.checkBoxData, false)
            })
        }
    }

    shareWorkSheetAction(data) {

        const { dispatch } = this.props

        let email_idArr = data.email_id.split(',')

        let dataObj = {
            worksheet: parseInt(this.state.workSheetId, 10),
            shared_to: email_idArr
        }

        dispatch(worksheetAction.shareWorksheetHandler(dataObj))


    }


    removeShareAction(data) {

        const { dispatch } = this.props;

        let dataObj = {
            share_id: this.state.dataToDelete
        };

        dispatch(worksheetAction.removeSharingWorksheetHandler({ data: dataObj, workSheetId: this.state.workSheetId }))

    }

    render() {

        const { getSharedWithUsersLoading, getSharedError } = this.props;
        const heading = this.props.location.state
        return (
            <div className="worksheet-shared">
                <NavBar />
                {
                    this.state.idLoader ?
                        <div style={{ height: 'calc(100vh - 150px)' }} className="container d-flex justify-content-center">
                            <LoaderComp color={'black'} />
                        </div>
                        :
                        this.state.hasProperId ?
                            <div>
                                {
                                    heading ?
                                        <div className="container mb-5">
                                            <CommonBreadCrumb
                                                data={[
                                                    {
                                                        link: '/app/dashBoard',
                                                        name: 'DASHBOARD'
                                                    }, {
                                                        link: '/app/dashBoard/workSheet',
                                                        name: 'GOAL-SETTING WORKSHEETS'
                                                    }, {
                                                        link: `/app/dashBoard/workSheet/${this.state.workSheetId}`,
                                                        name: 'WORKSHEET DETAILS'
                                                    }, {
                                                        link: '',
                                                        name: 'MANAGE WORKSHEET SHARE'
                                                    }
                                                ]}
                                            />
                                            <div style={{ height: 40 }} className="bg-green rounded-top animation-fade-in">
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <p></p>
                                                    <p className="h6 text-center text-uppercase py-2 text-white mb-0 quattrocentosans regular">{heading.orientation__orientation_name !== null ? heading.orientation__orientation_name + '- ORIENTATION ' : ''} {heading.worksheet_name}</p>
                                                    {
                                                        (!getSharedWithUsersLoading && !getSharedError) ?
                                                            <p></p>
                                                            :
                                                            <LoaderComp color={'white'} />
                                                    }
                                                </div>
                                            </div>
                                            <SettingsHead
                                                buttonData={this.state.sharedButtonData}
                                                columns={table.worksheetManageShare}
                                                view={this.filterData.bind(this)}
                                                sellers={this.props.getSharedWithUsersData}
                                                showModal={false}
                                                filter="true"
                                                widthClass={'col-md-6'}
                                            />
                                            <CustomTableNew
                                                checkboxData={this.state.checkBoxData}
                                                checkbox="true"
                                                selectCheckBox={this.selectAllBatch.bind(this)}
                                                getData={this.getSelectedData.bind(this)}

                                                CheckKey={'shared_to__email'}
                                                data={this.state.getSharedWithUsersData}
                                                columns={table.worksheetManageShare}
                                                showSlNo="true"
                                            />
                                        </div>
                                        :
                                        null
                                }
                            </div>
                            :
                            <Page404 unauthorised={true} />
                }
                <Footer />
                {
                    this.state.shareWorkSheetState ?
                        <ModalNew2
                            heading="RESPONDENT DETAILS"
                            showModal={this.state.shareWorkSheetState}
                            formData={[{
                                is_email: true,
                                key: 'email_id',
                                type: 'textarea',
                                value: '',
                                valid: false,
                                commaSepareted: true,
                                textBelowInput: '<p style="text-align: center; font-size: 12px; color: #8a5e5e;">(You can enter multiple IDs as comma-separated values.)</p>',

                                regex: '',
                                elementConfig: {
                                    name: 'email',
                                    label: false,
                                    placeholder: 'name@company.com'
                                },
                                validation: {
                                    required: true,
                                    message: "is required"
                                }
                            }]}
                            action={(data) => this.shareWorkSheetAction(data)}
                            toggleModal={this.shareWorkSheetToggler.bind(this)}
                            viewMessage={[]}
                            triggerType={"SUBMIT"}
                            noReset={'noReset'}
                        />
                        :
                        null
                }
                {
                    this.state.removeShareState ?
                        <ModalNew2
                            heading="RESPONDENT DETAILS"
                            showModal={this.state.removeShareState}
                            formData={[]}
                            action={(data) => this.removeShareAction(data)}
                            toggleModal={this.removeShareToggler.bind(this)}
                            viewMessage={this.state.removeShareMessage}
                            triggerType={"SUBMIT"}
                            noReset={'noReset'}
                        />
                        :
                        null
                }
            </div>
        )
    }
}

const mapStateToProps = state => {
    const getSharedError = state.getSharedWithUsersReducer.error;
    const { getSharedWithUsersLoading } = state.getSharedWithUsersReducer;
    const getSharedWithUsersData = (!getSharedError && !getSharedWithUsersLoading) ? state.getSharedWithUsersReducer.data.data.shared_with_list : ''
    return {
        getSharedWithUsersData,
        getSharedWithUsersLoading,
        getSharedError
    }
}

export default connect(mapStateToProps)(WorksheetShare)


// WEBPACK FOOTER //
// ./src/_pages/DashBoard/worksheet/worksheetdetails/worksheetShared/shared.jsx